import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import styles from 'modules/Statistics/statistics.module.scss'

const StatisticsLayout = ({
  ChartComponent,
  TableComponent,
  BreadcrumbsComponent = null,
  FilterPanel = null,
  chartVisible = true,
}) => {
  const tableContainerRef = useRef()

  return (
    <>
      <div className={'margin-bottom-32'}>
        {BreadcrumbsComponent}
        {FilterPanel}
      </div>

      <div
        className={clsx(styles['chart-wrapper'], {
          [styles['chart-wrapper_hidden']]: !chartVisible,
          ['margin-bottom-32']: chartVisible,
        })}
      >
        {ChartComponent}
      </div>

      <div
        className={styles['table-container']}
        ref={tableContainerRef}
      >
        {TableComponent}
      </div>
    </>
  )
}

StatisticsLayout.propTypes = {
  ChartComponent: PropTypes.element,
  TableComponent: PropTypes.element,
  BreadcrumbsComponent: PropTypes.element,
  FilterPanel: PropTypes.element,
  chartVisible: PropTypes.bool,
}

export default StatisticsLayout
